import PropTypes from "prop-types";
import React from "react";
import styles from "./SettingsMenuTitle.css";

export const SettingsMenuTitle = (props) => (
  <div className={styles.title} {...props}>
    <i className={`${props.icon} ${styles.icon}`} />
    <span className={styles.text}>{props.children}</span>
  </div>
);

SettingsMenuTitle.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
};
